"use client"
import React, { useState, useEffect } from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useAppData } from "@/lib/providers/AppDataProvider";
import "@/components/locator/LocatorSearchFilters.css";
import { useMediaQuery } from "react-responsive";

const ServiceProfileFilters = ({
  className,
  onFilterChange,
  searchResults,
  onCategorySelected
}) => {
  const compressFilters = useMediaQuery({ query: "(max-width: 425px)" });

  const { flattenedServiceCategories: serviceCategoriesFlattened } = useAppData();

  const [categoryOptions, setCategoryOptions] = useState(null);

  useEffect(() => {
    let topLevelCategories = serviceCategoriesFlattened.filter(
      category => category.group == null
    );
    const halfLength = Math.ceil(topLevelCategories.length / 2);
    const firstHalf = topLevelCategories.slice(0, halfLength);
    const secondHalf = topLevelCategories.slice(halfLength);

    const interleaved = [];
    for (let i = 0; i < Math.max(firstHalf.length, secondHalf.length); i++) {
      if (i < firstHalf.length) interleaved.push(firstHalf[i]);
      if (i < secondHalf.length) interleaved.push(secondHalf[i]);
    }

    setCategoryOptions(interleaved);
  }, [serviceCategoriesFlattened]);

  // const [categoryElements, setCategoryElements] = useState(null);

  // useEffect(() => {
  //   setCategoryElements(
  //     serviceCategoriesFlattened
  //       .filter(category => category.group == null)
  //       .map(category => (
  //         <div
  //           key={category.value}
  //           style={{ cursor: "pointer" }}
  //           className="btn btn-sm btn-secondary with-icon"
  //           onClick={() => onCategorySelected(category)}
  //         >
  //           <i className={`fa-solid fa-${category.icon}`}></i>
  //           {category.label}
  //         </div>
  //       ))
  //   );
  // }, [serviceCategoriesFlattened]);

  const conditionLabels = {
    NEW: "New",
    USED: "Used - Reusable",
    USED_NON_REUSABLE: "Used - Non-Reusable"
  };

  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedCondition, setSelectedCondition] = useState(null);
  const [deliveryAvailable, setDeliveryAvailable] = useState(false);
  const [pickupAvailable, setPickupAvailable] = useState(false);

  useEffect(() => {
    onFilterChange(
      selectedAction,
      selectedCondition,
      deliveryAvailable,
      pickupAvailable
    );
  }, [selectedAction, selectedCondition, deliveryAvailable, pickupAvailable]);

  return (
    <div className="search-filters">
      {searchResults != null ? (
        <>
          <div
            className={`default-flex-row-layout ${className}`}
            // style={{ margin: "0.5rem 1.25rem 0.5rem 0.75rem" }}
          >
            <Dropdown onSelect={setSelectedAction}>
              <Dropdown.Toggle
                variant="secondary"
                className="btn btn-sm btn-secondary"
                style={{ width: "8rem" }}
              >
                {selectedAction
                  ? selectedAction.charAt(0).toUpperCase() +
                    selectedAction.slice(1).toLowerCase()
                  : "I want to"}
                <div className="flex-grow" />
              </Dropdown.Toggle>
              <Dropdown.Menu
                renderOnMount={true}
                popperConfig={{ strategy: "fixed" }}
              >
                {selectedAction && (
                  <Dropdown.Item eventKey={null}>Show All</Dropdown.Item>
                )}
                <Dropdown.Item eventKey="BUY">Shop</Dropdown.Item>
                <Dropdown.Item eventKey="SELL">Sell</Dropdown.Item>
                <Dropdown.Item eventKey="RENT">Rent</Dropdown.Item>
                <Dropdown.Item eventKey="BORROW">Borrow</Dropdown.Item>
                <Dropdown.Item eventKey="DONATE">Donate</Dropdown.Item>
                <Dropdown.Item eventKey="RECYCLE">Recycle</Dropdown.Item>
                <Dropdown.Item eventKey="DISPOSE">Dispose</Dropdown.Item>
                <Dropdown.Item eventKey="REPAIR">Repair</Dropdown.Item>
                <Dropdown.Item eventKey="COMPOST">Compost</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown onSelect={setSelectedCondition}>
              <Dropdown.Toggle
                variant="secondary"
                className="btn btn-sm btn-secondary"
                style={{ width: "11rem" }}
              >
                {selectedCondition
                  ? conditionLabels[selectedCondition]
                  : "In what Condition"}
                <div className="flex-grow" />
              </Dropdown.Toggle>
              <Dropdown.Menu
                renderOnMount={true}
                popperConfig={{ strategy: "fixed" }}
              >
                {selectedCondition && (
                  <Dropdown.Item eventKey={null}>Show All</Dropdown.Item>
                )}
                <Dropdown.Item eventKey="NEW">New</Dropdown.Item>
                <Dropdown.Item eventKey="USED">Used - Reusable</Dropdown.Item>
                <Dropdown.Item eventKey="USED_NON_REUSABLE">
                  Used - Non-Reusable
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            {compressFilters ? (
              <Dropdown>
                <Dropdown.Toggle
                  variant="secondary"
                  className="btn btn-sm btn-secondary"
                  style={{ minWidth: "2rem" }}
                  title="More"
                ></Dropdown.Toggle>
                <Dropdown.Menu
                  renderOnMount={true}
                  popperConfig={{ strategy: "fixed" }}
                >
                  <Dropdown.Item
                    as="div"
                    className="dropdown-item with-icon"
                    eventKey="delivery"
                    onClick={() => setDeliveryAvailable(!deliveryAvailable)}
                  >
                    <span key="delivery-available-icon">
                      <i className="fa-solid fa-person-carry-box"></i>
                    </span>
                    <span className="medium">Delivery Available</span>
                    {deliveryAvailable ? (
                      <span key="delivery-available-check">
                        <i className="fa-solid fa-check"></i>
                      </span>
                    ) : (
                      <></>
                    )}
                  </Dropdown.Item>
                  <Dropdown.Item
                    as="div"
                    className="dropdown-item with-icon"
                    eventKey="pickup"
                    onClick={() => setPickupAvailable(!pickupAvailable)}
                  >
                    <span key="pickup-available-icon">
                      <i className="fa-solid fa-truck-pickup"></i>
                    </span>
                    <span className="medium">Pickup Available</span>
                    {pickupAvailable ? (
                      <span key="pickup-available-check">
                        <i className="fa-solid fa-check"></i>
                      </span>
                    ) : (
                      <></>
                    )}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <>
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Delivery Available?</Tooltip>}
                >
                  <div
                    style={{ width: "2rem" }}
                    className={`btn btn-sm btn-secondary with-icon${
                      deliveryAvailable ? " active" : ""
                    }`}
                    onClick={() => setDeliveryAvailable(!deliveryAvailable)}
                  >
                    <i className="fa-solid fa-person-carry-box"></i>
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Pickup Available?</Tooltip>}
                >
                  <div
                    style={{ width: "2rem" }}
                    className={`btn btn-sm btn-secondary with-icon${
                      pickupAvailable ? " active" : ""
                    }`}
                    onClick={() => setPickupAvailable(!pickupAvailable)}
                  >
                    <i className="fa-solid fa-truck-pickup"></i>
                  </div>
                </OverlayTrigger>
              </>
            )}
            <div className="flex-grow" />
          </div>
        </>
      ) : (
        <>
          <Dropdown
            onSelect={category => {
              const selectedCategory = categoryOptions.find(
                c => c.value === category
              );
              onCategorySelected(selectedCategory);
            }}
          >
            <Dropdown.Toggle
              variant="secondary"
              className="btn btn-sm btn-secondary"
              style={{ width: "12rem" }}
            >
              Search by Category
              <div className="flex-grow" />
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="multi-column-dropdown"
              renderOnMount={true}
              popperConfig={{ strategy: "fixed" }}
            >
              {categoryOptions?.map(category => (
                <Dropdown.Item className="with-icon" eventKey={category.value}>
                  <i className={`fa-solid fa-${category.icon}`}></i>
                  {category.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </>
      )}
    </div>
  );
};

export default ServiceProfileFilters;
